export const PAGE_CHANGE = 'pageChange';
export const VIEW_ALL = 'viewAll';
export const PLAYLIST_END = 'playlistEnd';
